import { render, staticRenderFns } from "./UserProfiles.vue?vue&type=template&id=966fb7fa&scoped=true&"
import script from "./UserProfiles.vue?vue&type=script&lang=js&"
export * from "./UserProfiles.vue?vue&type=script&lang=js&"
import style0 from "./UserProfiles.vue?vue&type=style&index=0&id=966fb7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966fb7fa",
  null
  
)

export default component.exports